import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import AnimatedStarIcon from 'Components/icons/StarIcon/Animate';
import CheckIcon from 'Components/icons/check-icon';
import CloseIcon from 'Components/icons/CloseIcon';
import Button from 'Components/Button';
import Search from 'Components/search';
import FavoritesIcon from 'Components/icons/StarIcon';
import SearchIcon from 'Components/icons/SearchIcon';
import Badge from 'Components/Badge';
import './GDGolbalFilterSelectorSearchManager.scss';

class GDGolbalFilterSelectorSearchManager extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: props.searchText,
      searchValue: props.searchValue,
      searchQuery: props.searchQuery,
      isclose: false,
      acquirerCode:JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode,
    };

    this.attachBindings();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.searchText !== this.state.searchText) {
      this.setState({
        searchText: nextProps.searchText,
      });
    }
  }

  onSearchTextFocus(searchText) {
    this.props.onSearchTextFocus(searchText);
  }

  onSearchTextChange(searchText) {
    this.setState({
      searchText,
    }, this.props.onSearchTextChange(searchText));
  }

  onClearSearchTextClick() {
    this.props.toggleFavorites('', '', true, '');
  }

  onClickSearchText() {
    this.props.toggleFavorites('', '', true, this.props.searchValue);
  }

  handleIconType(iconType) {
    const { onFavoritesListClick } = this.props;
    if (iconType === 'saving') { // animate loading
      return (
        <Button
          extraClass="favorites-btn"
          category="link-inline"
        >
          <div className="animatedStarIcon-wrapper">
            <AnimatedStarIcon loadingInfinite />
          </div>
        </Button>
      );
    } else if (iconType === 'saved') { // check icon
      return (
        <Button
          extraClass="favorites-btn"
          category="link-inline"
          action={onFavoritesListClick}
        >
          <CheckIcon animate />
        </Button>
      );
    } else {
      return ( // default star
        <div>
          <Button
            extraClass="favorites-btn"
            category="link-inline"
            action={onFavoritesListClick}
          >
            <FavoritesIcon filled />
          </Button>

        </div>
      );
    }
  }

  attachBindings() {
    this.handleIconType = this.handleIconType.bind(this);
    this.onClearSearchTextClick = this.onClearSearchTextClick.bind(this);
    this.onSearchTextChange = this.onSearchTextChange.bind(this);
    this.onSearchTextFocus = this.onSearchTextFocus.bind(this);
    this.onClickSearchText = this.onClickSearchText.bind(this);
  }

  render() {
    const isIE = /* @cc_on!@ */false || !!document.documentMode;
    const { searchText } = this.state;
    const {
      extraClass,
      iconType,
      onFavoritesListClick,
      onRecentSearchListClick,
      onSelectionsListClick,
      triggerFavorites,
      triggerSaveSelectionForm,
      numberSelected,
      translations,
      saveComplete,
      searchValue,
      searchQuery,
      handleClose,
      isclose,
    } = this.props;

    const wrapperClass = classnames('gd-hierarchy-selector-search-manager', {
      [extraClass]: extraClass,
    });

    const numberSelectedBadgeJsx = numberSelected === 0 ? null :
      (
        <div>
          <Button
            action={onSelectionsListClick}
            category="link-inline"
          >
            <Badge
              badgeType="hierarchy-selector"
            >
              <span className="number-selected">{numberSelected}</span>SELECTED
            </Badge>
          </Button>

        </div>
      );

    const clearSearchInputButtonJsx = searchText === '' ? null :
      (
        <div>
          <Button
            action={this.onClearSearchTextClick}
            className="gd-hierarchy-selector-search-manager__clear"
            category="link-inline"
          >
            <CloseIcon />
          </Button>
        </div>
      );


    const searchresultText = (
      <div onClick={this.onClickSearchText} >{searchValue}<span className="search-div ">{searchQuery}</span>
      </div>
    );

    return (
      <div className={wrapperClass} >
        <Button
          action={onRecentSearchListClick}
          extraClass={"search-btn search-btn_"+this.state.acquirerCode}
          category="link-inline"
        >

          <SearchIcon />

        </Button>

        {triggerFavorites || triggerSaveSelectionForm ?
          '' :
          <div className="search-selection-container">
            <Search
              manager
              filterText={searchText}
              onChange={this.onSearchTextChange}
              onFocus={this.onSearchTextFocus}
              placeholder={translations.placeholder}
              debounceTimeout={500}
            />
            {clearSearchInputButtonJsx}
            {numberSelectedBadgeJsx}
          </div>
        }
        {triggerFavorites ?
          <div className="hidden-title" style={{ marginTop: isIE && '2px' }}>
            {!this.state.isclose ? searchresultText : ' '}
            <Button
              action={this.onClearSearchTextClick}
              className="gd-hierarchy-selector-search-manager__clear"
              category="link-inline"
            >
              <CloseIcon />
            </Button>

          </div> : ''

        }

      </div>
    );
  }
}

GDGolbalFilterSelectorSearchManager.propTypes = {
  extraClass: PropTypes.string,
  iconType: PropTypes.string,
  numberSelected: PropTypes.number,
  onFavoritesListClick: PropTypes.func,
  onRecentSearchListClick: PropTypes.func,
  onSearchTextChange: PropTypes.func,
  onSearchTextFocus: PropTypes.func,
  onSelectionsListClick: PropTypes.func,
  saveComplete: PropTypes.bool,
  searchText: PropTypes.string,
  triggerFavorites: PropTypes.bool,
  triggerSaveSelectionForm: PropTypes.bool,
  translations: PropTypes.object.isRequired,
  toggleFavorites: PropTypes.func,
};

GDGolbalFilterSelectorSearchManager.defaultProps = {
  extraClass: '',
  iconType: 'default',
  numberSelected: 0,
  onFavoritesListClick: () => { },
  onRecentSearchListClick: () => { },
  onSearchTextChange: () => { },
  onSearchTextFocus: () => { },
  onSelectionsListClick: () => { },
  saveComplete: false,
  searchText: '',
  triggerFavorites: false,
  triggerSaveSelectionForm: false,
  toggleFavorites: () => { },
};

export default GDGolbalFilterSelectorSearchManager;
